// extracted by mini-css-extract-plugin
export var dropdownContainer = "_n7-0";
export var leftAlign = "_n7-4";
export var listItem = "_n7-2";
export var listItemWrapper = "_n7-1";
export var operationText = "_n7-3";